export enum SHLApp {
  IS_SHLAPP_AGENT = 'ISSHLAPPAGENT',
  IS_SHLAPP_ANDROID_AGENT = 'ISANDROIDAGENT',
  IS_SHLAPP_IOS_AGENT = 'ISIOSAGENT',
  IS_TASK_LIST = 'task-list',
}

export enum DisplayOptions {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
  MOBILE_APP = 'MOBILE_APP',
  TABLET = 'TABLET',
}

export enum ExperienceURL {
  TASKLIST_URL = 'TASKLIST_URL',
  SCORE_EVALUATION_URL = 'SCORE_EVALUATION_URL',
}
